<div class="context-toggle" cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="toggle()">
  <ng-content select="[button]"></ng-content>
</div>

<ng-template cdkConnectedOverlay appOverlayPanel
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="open"
  [panelPositions]="positions"
  (panelClose)="open = false">
  <div class="context-menu">
    @for (action of actions; track action) {
      @if (action.callback) {
        <div (click)="handleAction(action, $event)"
          [class]="(action.classes ? action.classes : '') + (!action.isEnabled ? ' disabled' : '') + ' context-menu-action'"
          [title]="action.text">
          @if (action.text) {
            <span class="action-text">{{ action.text }}</span>
          }
          @if (action.maticon) {
            <i
              [ngClass]="action.maticonStyle ? 'material-icons-' + action.maticonStyle : 'material-icons'"
            class="action-icon">{{ action.maticon }}</i>
          }
          @if (action.icon) {
            <span [inlineSVG]="'/assets/img/' + action.icon" class="action-icon"></span>
          }
        </div>
      }
      @if (action.link && action.link.inner) {
        <a (click)="handleAction(action, $event)"
          [class]="(action.classes ? action.classes : '') + (!action.isEnabled ? ' disabled' : '') + ' context-menu-action'"
          [routerLink]="action.link.href"
          [target]="action.link.target ? action.link.target : '_parent'"
          [title]="action.text">
          @if (action.text) {
            <span class="action-text">{{ action.text }}</span>
          }
          @if (action.maticon) {
            <i class="material-icons action-icon">{{ action.maticon }}</i>
          }
          @if (action.icon) {
            <span [inlineSVG]="'/assets/img/' + action.icon" class="action-icon"></span>
          }
        </a>
      }
      @if (action.link && !action.link.inner) {
        <a (click)="handleAction(action, $event)"
          [class]="(action.classes ? action.classes : '') + (!action.isEnabled ? ' disabled' : '') + ' context-menu-action'"
          [href]="action.link.href"
          [target]="action.link.target ? action.link.target : '_parent'"
          [title]="action.text">
          @if (action.text) {
            <span class="action-text">{{ action.text }}</span>
          }
          @if (action.maticon) {
            <i class="material-icons action-icon">{{ action.maticon }}</i>
          }
          @if (action.icon) {
            <span [inlineSVG]="'/assets/img/' + action.icon" class="action-icon"></span>
          }
        </a>
      }
    }
  </div>
</ng-template>
